/* fothermo – Erklärgrafiken Solarheizstab WIFI PRO (PV-Überschuss, Regelprinzip) */
(function () {
  'use strict';
  if (window.__foWifipro) return;
  window.__foWifipro = true;

  var lang = (document.documentElement.lang || 'de').slice(0, 2);
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nf = function (n, d) { return n.toLocaleString(lang, { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); };
  var watt = function (w) { return nf(Math.round(w / 10) * 10) + ' W'; };
  var kw = function (w) { return nf(w / 1000, 1) + ' kW'; };

  function onVisible(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { fn(); io.disconnect(); } });
    }, { threshold: 0.35 });
    io.observe(el);
  }

  /* PV-Überschuss im Tagesverlauf ------------------------------------------ */
  function bump(h, mid, width) { return Math.exp(-Math.pow(h - mid, 2) / (2 * width * width)); }
  function pv(h) {                       // Beispiel 8 kWp, sonniger Tag, Spitze ca. 6,2 kW
    var edge = bump(6.2, 13.2, 2.5);
    return Math.max(0, 6200 * (bump(h, 13.2, 2.5) - edge) / (1 - edge));
  }
  function load(h) {                     // typischer Haushalt: Grundlast, Morgen-, Mittags- und Abendspitze
    return 350 + 900 * bump(h, 7.2, 0.55) + 700 * bump(h, 12.2, 0.6) + 400 * bump(h, 15.8, 0.9) + 1500 * bump(h, 19.1, 1);
  }

  document.querySelectorAll('[data-surplus]').forEach(function (root) {
    var limit = parseFloat(root.dataset.limit) || 3000;
    var price = parseFloat(root.dataset.feedin) || 8;
    var mode = 0, H0 = 5, H1 = 21, X0 = 40, X1 = 700, Y0 = 260, Y1 = 20, PMAX = 7000;
    var x = function (h) { return X0 + (h - H0) / (H1 - H0) * (X1 - X0); };
    var y = function (w) { return Y0 - w / PMAX * (Y0 - Y1); };
    var q = function (sel) { return root.querySelector(sel); };
    var timeIn = q('[data-time]');

    // Raster und Achsen
    var ns = 'http://www.w3.org/2000/svg', grid = q('[data-grid]'), g = '';
    [0, 2000, 4000, 6000].forEach(function (w) {
      g += '<line x1="' + X0 + '" x2="' + X1 + '" y1="' + y(w) + '" y2="' + y(w) + '"/>' +
           '<text x="' + (X0 - 8) + '" y="' + (y(w) + 4) + '" text-anchor="end">' + (w / 1000) + ' kW</text>';
    });
    [6, 9, 12, 15, 18, 21].forEach(function (h) {
      g += '<text x="' + x(h) + '" y="' + (Y0 + 22) + '" text-anchor="middle">' + h + ':00</text>';
    });
    grid.innerHTML = g;
    grid.setAttribute('xmlns', ns);

    function line(fn) {
      var d = '';
      for (var h = H0; h <= H1 + 1e-9; h += 0.1) d += (d ? 'L' : 'M') + x(h).toFixed(1) + ',' + y(fn(h)).toFixed(1);
      return d;
    }
    function area(lower, upper) {        // Fläche zwischen zwei Kurven, nur wo upper > lower
      var top = [], bottom = [];
      for (var h = H0; h <= H1 + 1e-9; h += 0.1) {
        var lo = lower(h), hi = Math.max(lo, upper(h));
        top.push(x(h).toFixed(1) + ',' + y(hi).toFixed(1));
        bottom.unshift(x(h).toFixed(1) + ',' + y(lo).toFixed(1));
      }
      return 'M' + top.join('L') + 'L' + bottom.join('L') + 'Z';
    }
    q('[data-line-pv]').setAttribute('d', line(pv));
    q('[data-line-load]').setAttribute('d', line(load));

    // Warmwasser je Zeitpunkt: Überschuss bis zur Heizleistung, bis der Speicher voll ist
    var tankL = parseFloat(root.dataset.tank) || 300;
    var tankWh = tankL * 45 * 1.163;     // Speicher von 15 auf 60 °C
    var STEP = 0.05, waterAt = {}, full = null, sumGrid0 = 0, sumGrid1 = 0, sumWater = 0;
    for (var h = H0, acc = 0; h <= H1 + 1e-9; h += STEP) {
      var s = Math.max(0, pv(h) - load(h)), w = Math.min(s, limit, Math.max(0, (tankWh - acc) / STEP));
      acc += w * STEP;
      if (full === null && acc >= tankWh - 1) full = h;
      waterAt[h.toFixed(2)] = w;
      sumGrid0 += s * STEP; sumWater += w * STEP; sumGrid1 += (s - w) * STEP;
    }
    var water = function (h) { var k = (Math.round(h / STEP) * STEP).toFixed(2); return waterAt[k] || 0; };
    var heated = function (h) { return load(h) + water(h); };
    function drawAreas() {
      var fm = q('[data-full]');
      if (fm) {
        if (mode && full !== null) {
          var fx = x(full), ln = fm.querySelector('line'), rc = fm.querySelector('rect'), tx = fm.querySelector('text');
          ln.setAttribute('x1', fx); ln.setAttribute('x2', fx);
          rc.setAttribute('x', fx - 52); rc.setAttribute('y', 18);
          tx.setAttribute('x', fx); tx.setAttribute('y', 33);
          fm.style.display = '';
        } else fm.style.display = 'none';
      }
      if (mode) {
        q('[data-fill-water]').setAttribute('d', area(load, heated));
        q('[data-fill-grid]').setAttribute('d', area(heated, pv));
      } else {
        q('[data-fill-water]').setAttribute('d', '');
        q('[data-fill-grid]').setAttribute('d', area(load, pv));
      }
    }

    function sumText() {
      var el = q('[data-sum]'), t = mode ? el.dataset.textWith : el.dataset.textWithout;
      var liters = Math.min(tankL, sumWater / (45 * 1.163));
      return t.replace('[grid]', '<strong>' + nf(sumGrid0 / 1000, 1) + ' kWh</strong>')
              .replace('[water]', '<strong>' + nf(sumWater / 1000, 1) + ' kWh</strong>')
              .replace('[liters]', '<strong>' + nf(Math.round(liters / 10) * 10) + ' Liter</strong>')
              .replace('[money]', '<strong>' + nf(sumGrid0 / 1000 * price / 100, 2) + ' €</strong>');
    }

    function render(h) {
      var p = pv(h), l = load(h), s = Math.max(0, p - l), w = mode ? water(h) : 0;
      q('[data-cursor]').setAttribute('x1', x(h)); q('[data-cursor]').setAttribute('x2', x(h));
      q('[data-dot-pv]').setAttribute('cx', x(h)); q('[data-dot-pv]').setAttribute('cy', y(p));
      q('[data-dot-load]').setAttribute('cx', x(h)); q('[data-dot-load]').setAttribute('cy', y(l));
      var hh = Math.floor(h), mm = Math.round((h - hh) * 60);
      q('[data-out-time]').textContent = hh + ':' + (mm < 10 ? '0' : '') + mm;
      q('[data-out-pv]').textContent = kw(p);
      q('[data-out-load]').textContent = kw(l);
      q('[data-out-grid]').textContent = kw(s - w);
      q('[data-out-water]').textContent = kw(w);
    }

    function setMode(m) {
      mode = m;
      root.classList.toggle('is-with', !!m);
      root.querySelectorAll('[data-mode]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.mode === m)); });
      q('[data-legend-water]').hidden = !m;
      q('[data-water-box]').hidden = !m;
      q('[data-sum]').innerHTML = sumText();
      drawAreas();
      render(parseFloat(timeIn.value));
    }
    root.querySelectorAll('[data-mode]').forEach(function (b) {
      b.addEventListener('click', function () { setMode(+b.dataset.mode); });
    });
    timeIn.addEventListener('input', function () { render(parseFloat(timeIn.value)); });
    setMode(0);

    // Beim ersten Sichtbarwerden einmal durch den Vormittag laufen
    if (!reduced) {
      timeIn.value = 7; render(7);
      onVisible(root, function () {
        var t0 = null, from = 7, to = 13;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 1800), e = 1 - Math.pow(1 - p, 3), v = from + (to - from) * e;
          timeIn.value = v; render(v);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }
  });

  /* Regelprinzip: 1 × stufenlos 0–1000 W, 2 × zuschaltbar je 1000 W --------- */
  document.querySelectorAll('[data-ctrl]').forEach(function (root) {
    var sIn = root.querySelector('[data-surplus-in]'), lIn = root.querySelector('[data-limit-in]');
    var rods = root.querySelectorAll('[data-rod]'), hint = root.querySelector('[data-hint]');
    function render() {
      var s = +sIn.value, lim = +lIn.value, use = Math.min(s, lim);
      var r2 = use >= 1000 ? 1000 : 0, r3 = use >= 2000 ? 1000 : 0, r1 = use - r2 - r3;
      [r1, r2, r3].forEach(function (w, i) {
        rods[i].style.setProperty('--heat', (w / 1000).toFixed(3));
        rods[i].classList.toggle('is-on', w > 0);
        rods[i].querySelector('[data-rod-w]').textContent = watt(w);
      });
      root.querySelector('[data-out-surplus]').textContent = watt(s);
      root.querySelector('[data-out-limit]').textContent = watt(lim);
      root.querySelector('[data-out-water]').textContent = watt(use);
      root.querySelector('[data-out-grid]').textContent = watt(s - use);
      root.classList.toggle('is-capped', s > lim);
      hint.textContent = s <= 0 ? hint.dataset.off : s > lim ? hint.dataset.limit : hint.dataset.on;
    }
    sIn.addEventListener('input', render);
    lIn.addEventListener('input', render);
    render();

    if (!reduced) {
      sIn.value = 0; render();
      onVisible(root, function () {
        var t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - p, 3);
          sIn.value = Math.round(1600 * e / 50) * 50; render();
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }
  });
})();
